import React from "react";

import styles from "./HeaderComponent.module.scss";
import classnames from "classnames";

export function HeaderTitle(props) {
    const { heading, body, headStyle, hideMobile, smallHeader } = props;
    return (
        <>
            {heading && (
                <h1 className={classnames(styles["header"], smallHeader && styles["header-small"], hideMobile && styles["hide-mobile"])} style={headStyle}>
                    {heading}
                </h1>
            )}
            {body && <p className={classnames(styles["text"], "potentially-black")}>{body}</p>}
        </>
    );
}

export function HeaderComponent(props) {
    const { dataTestId } = props;
    return (
        <section className={styles["section"]} data-test-id={dataTestId}>
            {/*<div className={classnames(styles["stepper-wrapper"], lodashIsNil(currentStep) && lodashIsNil(onBackClick) && styles["stepper-wrapper-hidden"])}>*/}
            {/*    <span style={{borderBottom: "2px solid black", marginRight: "10px"}}>{getLocaleText('timeline.step', {}, {preFormatFn: (t => t?.toUpperCase())})} {currentStep}/{maxSteps}</span>*/}
            {/*    <ButtonText {...props} onClick={onBackClick} className="potentially-bold" text={getLocaleText('return-items.back-button')}/>*/}
            {/*</div>*/}
            <HeaderTitle {...props} />
        </section>
    );
}
